export const generateRowOffsets = (rowsCount: number, rowHeight: number) => {
    return new Array(rowsCount).fill(null).map((value, idx) => idx * rowHeight);
};
